<template>
  <div class="mk-center">
    <div class="hender">
      <div class="patient-info">
        <span class="patient-name">{{ info.patientName }}</span>
        <span class="patient-gender">{{ common.gender(info.gender) }}</span>
        <span class="patient-age">{{ info.patientAge }}岁</span>
        <span>{{ info.cellphoneNo }}</span>
        <span>{{ info.diseaseName }}</span>
      </div>
      <patientLabels :info="info" :showEditBtn="false" />
      <div class="other" v-if="this.info.expertiseType != 4">
        <span>咨询医生：{{ info.doctorName }}</span>
        <span>被咨询医生：{{ info.benchmarkDoctorName }}</span>
      </div>
    </div>
    <messageBox ref="messageBoxRef" :info="info" />
    <div v-if="!['4', '6'].includes(this.info.expertiseType)" class="footer">
      <Input ref="inputRef" v-model="message" type="textarea" :rows="4" :placeholder="'发送给' +
        (info.expertiseType == 1 ? info.doctorName : info.benchmarkDoctorName)
        " />
      <div class="btn-group">
        <template v-if="showBtn">
          <!-- 非可回复状态，按钮禁用 -->
          <Button :disabled="info.dotType == 0" icon="md-add-circle" @click="showTreatmentPlan">治疗方案</Button>
          <Button :disabled="info.dotType == 0" @click="quote">引用上次方案</Button>
        </template>
        <Button class="btn-send" :disabled="!message" icon="md-send" type="primary" @click="sendMessage">发送</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    showBtn() {
      return (!this.info.forwardDoctorId || this.info.forwardDoctorId && this.info.forwardDoctorId == this.userInfo.husDoctorId) &&
        this.info.expertiseType == 1 && !this.info.planFlg;
    },
  },
  data() {
    return {
      message: "",
    };
  },
  watch: {
    info(newValue, oldValue) {
      this.init();
    },
  },
  methods: {
    quote() {
      this.$refs.messageBoxRef.quote();
    },
    showTreatmentPlan() {
      this.$refs.messageBoxRef.show();
    },
    sendMessage() {
      this.request
        .post("/zhbusiness/saveMedicalExpertiseRecord", {
          record: this.message,
          meId: this.info.meId,
        })
        .then((res) => {
          this.$Message.success(res.result);
          this.message = "";
          // 标记已经读
          // expertiseType 1 咨询我的 2 我咨询的
          // planFlg //是否有方案标记 1 有 0 没
          if (this.info.expertiseType == 1) {
            if (this.info.planFlg) {
              this.info.benchmarkReadFlg = 1;
            }
          } else {
            this.info.readFlg = 1;
          }

          this.$refs.messageBoxRef.getData();
        });
    },
    init() {
      if (this.$refs.inputRef) {
        this.$refs.inputRef.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mk-center {
  height: 100%;
  display: flex;
  flex-direction: column;

  .hender {
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;

    .patient-info {
      margin-bottom: 5px;
      font-weight: bold;
      font-size: 15px;

      &>span {
        margin-right: 15px;
      }

      .patient-name {
        font-size: 19px;
        color: #f00;
      }
    }

    .patient-labels {
      margin-bottom: 10px;
    }

    .other {
      font-size: 13px;

      span {
        margin-right: 15px;
      }
    }
  }

  .footer {
    padding: 15px 20px;
    position: relative;

    .btn-group {
      position: absolute;
      bottom: 30px;
      right: 30px;

      .ivu-btn {
        padding-left: 8px;
        padding-right: 8px;

        &.btn-send {
          background: #ffedee;
          color: #ff2b2b;

          &[disabled] {
            background: #f6f6f6;
            color: #d3d3d3;
          }
        }

        &+.ivu-btn {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>